import {
    CREATE_CHECKLIST,
    CREATE_CHECKLIST_SUCCESS,
    CREATE_CHECKLIST_FAIL,
    FETCH_FORMS_LIST,
    FETCH_FORMS_LIST_SUCCESS,
    FETCH_FORMS_LIST_FAIL,
    FETCH_STATION_WISE_FORMS,
    FETCH_STATION_WISE_FORMS_SUCCESS,
    FETCH_STATION_WISE_FORMS_FAIL,
    SUBMIT_FORM,
    SUBMIT_FORM_SUCCESS,
    SUBMIT_FORM_FAIL,
    VIEW_FORM,
    VIEW_FORM_SUCCESS,
    VIEW_FORM_FAIL,
    DOWNLOAD_CHECKLIST_FORM,
    DOWNLOAD_CHECKLIST_FORM_SUCCESS,
    DOWNLOAD_CHECKLIST_FORM_FAIL,
    STATUS_CHANGE,
    STATUS_CHANGE_SUCCESS,
    STATUS_CHANGE_FAIL,
    DELETE_CHECKLIST_FORM,
    DELETE_CHECKLIST_FORM_SUCCESS,
    DELETE_CHECKLIST_FORM_FAIL,
} from 'actions/formActions';
import { toast } from 'react-toastify';

const initialState = {
    loading: false,
    allFormsList: [],
    stationwiseformslist: [],
    viewFormData: {},
    approvalData: {},
    downloadedFile: {},
    downloadLoading: false,
    statusLoading: false,
    deleteLoading: false,
    error: null, // Added to store error messages
};

const checklistReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_FORMS_LIST:
        case CREATE_CHECKLIST:
        case FETCH_STATION_WISE_FORMS:
        case SUBMIT_FORM:
        case VIEW_FORM:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case STATUS_CHANGE:
            return {
                ...state,
                statusLoading: true,
                error: null,
            };

        case DELETE_CHECKLIST_FORM:
            return {
                ...state,
                deleteLoading: true,
                error: null,
            };

        case DOWNLOAD_CHECKLIST_FORM:
            return {
                ...state,
                downloadLoading: true,
                error: null,
            };

        case CREATE_CHECKLIST_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case FETCH_FORMS_LIST_SUCCESS:
            return {
                ...state,
                allFormsList: payload.data,
                loading: false,
            };

        case FETCH_STATION_WISE_FORMS_SUCCESS:
            return {
                ...state,
                stationwiseformslist: payload.data,
                loading: false,
            };

        case SUBMIT_FORM_SUCCESS:
            return {
                ...state,
                formData: payload.data,
                loading: false,
            };

        case VIEW_FORM_SUCCESS:
            return {
                ...state,
                viewFormData: payload.data,
                loading: false,
            };

        case DOWNLOAD_CHECKLIST_FORM_SUCCESS:
            toast.success("Form Downloaded");
            return {
                ...state,
                downloadedFile: payload,
                downloadLoading: false,
            };

        case STATUS_CHANGE_SUCCESS:
            return {
                ...state,
                approvalData: payload,
                statusLoading: false,
            };

        case DELETE_CHECKLIST_FORM_SUCCESS:
            toast.success("Form deleted successfully"); // Move toast to reducer for consistency
            return {
                ...state,
                deleteLoading: false,
                stationwiseformslist: state.stationwiseformslist.filter(
                    (form) => form._id !== payload.formId
                ), // Optimistically remove deleted form
            };

        case FETCH_FORMS_LIST_FAIL:
        case CREATE_CHECKLIST_FAIL:
        case FETCH_STATION_WISE_FORMS_FAIL:
        case SUBMIT_FORM_FAIL:
        case VIEW_FORM_FAIL:
            return {
                ...state,
                loading: false,
                error: payload?.message || 'An error occurred',
            };

        case DOWNLOAD_CHECKLIST_FORM_FAIL:
            return {
                ...state,
                downloadLoading: false,
                error: payload?.message || 'An error occurred',
            };

        case STATUS_CHANGE_FAIL:
            return {
                ...state,
                statusLoading: false,
                error: payload?.message || 'An error occurred',
            };

        case DELETE_CHECKLIST_FORM_FAIL:
            toast.error(`Failed to delete form: ${payload?.message || 'An error occurred'}`);
            return {
                ...state,
                deleteLoading: false,
                error: payload?.message || 'An error occurred',
            };

        default:
            return { ...state };
    }
};

export default checklistReducer;